import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgConversion = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 70 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M35 64H14.4342C13.2734 64 12.3583 63.0154 12.4146 61.856C13.329 43.0305 8.69951 22.828 1.06068 2.73997C0.559362 1.42164 1.52693 0 2.93736 0H67.0626C68.4731 0 69.4406 1.42164 68.9393 2.73996C61.3005 22.828 56.671 43.0305 57.5854 61.856C57.6417 63.0154 56.7266 64 55.5658 64H35Z",
		fill: "#C7DFFC"
	})
});
export default SvgConversion;
